"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractBorrowingBaseMechanicsConfig = exports.getConcentrationLimitConfigCode = exports.resolveSourceConfig = void 0;
const common_1 = require("@finley-technologies/common");
const concentrationLimitPointerMethods_1 = require("./airbaseGoldmanSachs1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_2 = require("./arcAtalaya1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_3 = require("./bmgMoneyAtlasSp1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_4 = require("./brimFinancialAtlasSp1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_5 = require("./capitalSouthwestCorporationIngCapital1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_6 = require("./cherryCrossRiverBank1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_7 = require("./cherrySiliconValleyBank1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_8 = require("./clearcoPollenStreetCapital1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_9 = require("./creditGenieFortress1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_10 = require("./enovaInternationalBmoCapitalMarketsCorp1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_11 = require("./enovaInternationalChase1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_12 = require("./enovaInternationalTruistBank1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_13 = require("./foraFinancialWarehouseLlcTruistBank1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_14 = require("./kafeneTpg1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_15 = require("./leucadiaNatixis1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_16 = require("./lunrI801/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_17 = require("./mercuryNatixis1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_18 = require("./mundiTradeSpv1Svb1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_19 = require("./neoFinancialAtbFinancial1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_20 = require("./nivodaI801/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_21 = require("./novoVictoryPark1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_22 = require("./oatFiArchitect1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_23 = require("./okinusBastion1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_24 = require("./oneBlincClearHaven1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_25 = require("./rainClearHaven1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_26 = require("./rainSoundPoint1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_27 = require("./rampGoldmanSachs1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_28 = require("./sunboundCoromandel1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_29 = require("./tripActionsGoldmanSachs1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_30 = require("./vayaPier1/concentrationLimitPointerMethods");
const concentrationLimitPointerMethods_31 = require("./viablyViola1/concentrationLimitPointerMethods");
const cfPointerConfigs = [
    concentrationLimitPointerMethods_1.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_2.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_3.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_4.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_6.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_7.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_5.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_9.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_10.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_11.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_12.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_13.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_14.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_15.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_16.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_17.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_18.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_19.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_20.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_21.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_22.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_23.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_24.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_25.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_26.concentrationLimitPointerMethods, // NOTE: this facility is no longer active.
    concentrationLimitPointerMethods_27.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_28.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_29.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_8.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_30.concentrationLimitPointerMethods,
    concentrationLimitPointerMethods_31.concentrationLimitPointerMethods,
];
const resolvePointerConfig = (pointerConfig) => {
    const allPointerMethodsConfigs = new Map();
    cfPointerConfigs.forEach((cfPointerConfig) => {
        cfPointerConfig.forEach((pointerMethodConfig) => {
            (0, common_1.finleyAssert)(!allPointerMethodsConfigs.has(pointerMethodConfig.method), `duplicate definition for pointerMethod ${pointerMethodConfig.method}`);
            allPointerMethodsConfigs.set(pointerMethodConfig.method, pointerMethodConfig);
        });
    });
    const resolvedPointerMethodConfig = allPointerMethodsConfigs.get(pointerConfig.method);
    (0, common_1.finleyAssert)(resolvedPointerMethodConfig, `[pointerMethod:${pointerConfig.method}] could not be resolved`);
    // Need to include base "pointerConfig" as it can house additional configs, like "filter" mechanics.
    // "resolvedPointerMethodConfig" then adds the actual pointer method function implementation
    return {
        ...pointerConfig,
        pointerImplementation: resolvedPointerMethodConfig.pointerImplementation,
        requiredFields: resolvedPointerMethodConfig.requiredFields,
    };
};
// for a given SourceConfig, returns ResolvedConfig.
const resolveCalculationConfig = (configToResolve) => {
    if (configToResolve.type === 'pointer') {
        return {
            ...configToResolve,
            type: 'resolvedPointer',
            config: resolvePointerConfig(configToResolve.config),
        };
    }
    return configToResolve;
};
// for a given PointerConfig, returns ResolvedPointerConfig.
// CreditAgreement.Config.ConcentrationLimit.ResolvedConfig
const resolveSourceConfig = (configToResolve) => {
    (0, common_1.finleyAssert)(configToResolve.calculationConfig, `inactive config ${configToResolve.propertyKey} could not be resolved`);
    return {
        ...configToResolve,
        calculationConfig: resolveCalculationConfig(configToResolve.calculationConfig),
    };
};
exports.resolveSourceConfig = resolveSourceConfig;
// returns stringified config (+ code for pointer methods)
const getConcentrationLimitConfigCode = (sourceConfig) => {
    if (!sourceConfig.calculationConfig) {
        return 'sourceConfig.calculationConfig is empty';
    }
    const resolved = (0, exports.resolveSourceConfig)(sourceConfig);
    if (resolved.calculationConfig.type !== 'resolvedPointer') {
        return 'no special code for this config';
    }
    return resolved.calculationConfig.config.pointerImplementation.toString();
};
exports.getConcentrationLimitConfigCode = getConcentrationLimitConfigCode;
const convertMultiLoanProductConfig = (input) => {
    if (input._config_.concentrationLimitConfig) {
        const resolvedConfig = (0, exports.resolveSourceConfig)(input._config_.concentrationLimitConfig);
        return {
            loanProductIds: input.loanProducts.map((loanProduct) => {
                return 'entity' in loanProduct
                    ? loanProduct.entity.id
                    : loanProduct._id_;
            }),
            ...resolvedConfig,
        };
    }
    return null;
};
// some concentration calcs can be inactive (for example clara's satConnectionEnterpriseAfter3Months)
// these will have missing calculationConfig
const isActiveConcentrationLimit = (value) => {
    return !!value.calculationConfig;
};
const convertLoanProduct = (input) => {
    const eligibilityTestConfigs = input.eligibilityTests
        .map((test) => test._config_.eligibilityTestConfig)
        .filter(common_1.typeguards.isNotNullOrUndefined);
    const concentrationLimitConfigs = input.concentrationLimits
        .map((test) => test._config_.concentrationLimitConfig)
        .filter(common_1.typeguards.isNotNullOrUndefined)
        .filter(isActiveConcentrationLimit)
        .map(exports.resolveSourceConfig);
    const receivableValuationRateConfig = input.receivableValuationRate._config_.receivableValuationRateConfig;
    const receivableAdvanceRateConfig = input.receivableAdvanceRate._config_.receivableAdvanceRateConfig;
    const purchasePercentageRateConfig = input.purchasePercentageRate._config_.purchasePercentageRateConfig;
    const loanProductId = 'entity' in input ? input.entity.id : input._id_;
    const value = {
        loanProductId,
        eligibilityTestConfigs,
        concentrationLimitConfigs,
        receivableValuationRateConfig,
        receivableAdvanceRateConfig,
        purchasePercentageRateConfig,
        _config_: input._config_,
    };
    return value;
};
// extracts config from CreditAgreement.DomainEntity.CalcAgentMechanics/CalcAgentMechanicsWithEntities
const extractBorrowingBaseMechanicsConfig = (calcAgentMechanics) => {
    return {
        multiLoanProductConcentrationLimits: calcAgentMechanics.multiLoanProductConcentrationLimits
            .map((srcMultiLoanProductConcentrationLimit) => convertMultiLoanProductConfig(srcMultiLoanProductConcentrationLimit))
            .filter(common_1.typeguards.isNotNullOrUndefined),
        loanProducts: calcAgentMechanics.loanProductMechanics.map(convertLoanProduct),
        _config_: calcAgentMechanics._config_,
    };
};
exports.extractBorrowingBaseMechanicsConfig = extractBorrowingBaseMechanicsConfig;
//# sourceMappingURL=bbmPointers.js.map